module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("Resumer")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("你好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("登出")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button primary"
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("预览")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.1@vue-loader/lib/template-compiler?{"id":"data-v-6c25eeb3"}!./~/_vue-loader@12.2.1@vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 84
// module chunks = 1